<template>
  <section class="login-page" aria-label="PC 端登录页面">
    <main class="login-card" aria-label="六合三分登录">
      <img class="brand" :src="asset('logo_login_xianjin_sts.png')" alt="六合三分">
      <div class="sponsor-title">赞助伙伴</div>
      <img class="sponsors" :src="asset('img_login_bg.png')" alt="赞助伙伴">

      <form class="login-form" autocomplete="off" @submit.prevent="submitLogin">
        <label class="field field-user">
          <img class="field-icon" :src="asset('ic_user.png')" alt="">
          <input v-model.trim="username" type="text" name="username" placeholder="请输入用户名" autocomplete="username" aria-label="请输入用户名">
        </label>
        <label class="field field-password">
          <img class="field-icon" :src="asset('ic_mima.png')" alt="">
          <input v-model="password" :type="showPassword ? 'text' : 'password'" name="password" placeholder="请输入密码" autocomplete="current-password" aria-label="请输入密码">
          <button class="password-toggle" type="button" :aria-label="showPassword ? '隐藏密码' : '显示密码'" @click="showPassword = !showPassword">
            <img :src="asset(showPassword ? 'btn_see_on.png' : 'btn_see_off.png')" alt="">
          </button>
        </label>
        <label class="field field-code">
          <img class="field-icon" :src="asset('ic_mima.png')" alt="">
          <input v-model.trim="captchaInput" type="text" name="captcha" placeholder="验证码" autocomplete="off" aria-label="验证码" maxlength="4">
        </label>
        <button class="captcha" type="button" aria-label="刷新验证码" @click="refreshCaptcha">
          <img :src="captchaUrl" alt="图形验证码" style="width:100%;height:100%;object-fit:fill">
        </button>
        <div class="form-options">
          <label class="remember" @click.prevent="rememberUsername = !rememberUsername">
            <img :src="asset(rememberUsername ? 'ic_sel.png' : 'ic_unsel.png')" alt="">
            <input v-model="rememberUsername" type="checkbox" hidden>记住账号
          </label>
          <button type="button" class="text-link" @click="showNotice('演示版请联系管理员重置密码。')">忘记密码?</button>
        </div>
        <button type="submit" class="login-button" :disabled="submitting">{{ submitting ? '登录中...' : '登 录' }}</button>
        <div class="register-line">没有账号，<button type="button" class="text-link" @click="showNotice('注册功能将在后端接入后开放。')">立即注册</button></div>
      </form>
    </main>

    <aside class="quick-tools" aria-label="快捷入口">
      <button class="quick-tool quick-download" aria-label="APP下载" @click="showNotice('APP 下载入口暂未配置。')"></button>
      <button class="quick-tool quick-service" aria-label="在线客服" @click="showNotice('聊天室安装完成后将在这里接入。')"></button>
      <button class="quick-tool quick-qq" aria-label="QQ客服" @click="showNotice('QQ 客服暂未配置。')"></button>
    </aside>
    <div class="login-notice" :class="{ visible: notice }" role="status" aria-live="polite">{{ notice }}</div>
  </section>
</template>

<script>
import { loginMember } from '../services/api'

const LOGIN_ASSET_ROOT = '/pc/assets/login/'
const USERNAME_KEY = 'boya-demo-username'

export default {
  name: 'LoginView',
  data () {
    return {
      username: '',
      password: '',
      captchaInput: '',
      captchaCode: '',
      captchaUrl: '',
      showPassword: false,
      rememberUsername: false,
      notice: '',
      noticeTimer: null,
      submitting: false
    }
  },
  mounted () {
    try {
      const savedUsername = window.localStorage.getItem(USERNAME_KEY)
      if (savedUsername) {
        this.username = savedUsername
        this.rememberUsername = true
      }
    } catch (_) {}
    this.refreshCaptcha()
  },
  beforeDestroy () {
    window.clearTimeout(this.noticeTimer)
  },
  methods: {
    asset (name) {
      return LOGIN_ASSET_ROOT + name
    },
    refreshCaptcha () {
      this.captchaUrl = '/index/login/getVerify?t=' + Date.now()
      this.captchaInput = ''
    },
    drawCaptcha () {
      const canvas = this.$refs.captcha
      if (!canvas) return
      const ctx = canvas.getContext('2d')
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      ctx.fillStyle = '#f5f2ed'
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      for (let index = 0; index < 15; index += 1) {
        ctx.strokeStyle = `hsl(${Math.random() * 360}, 55%, 58%)`
        ctx.lineWidth = 1
        ctx.beginPath()
        ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height)
        ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height)
        ctx.stroke()
      }
      ctx.font = 'bold 34px Georgia, serif'
      ctx.textBaseline = 'middle'
      this.captchaCode.split('').forEach((char, index) => {
        ctx.save()
        ctx.translate(13 + index * 29, 42)
        ctx.rotate((Math.random() - 0.5) * 0.38)
        ctx.fillStyle = `hsl(${Math.random() * 360}, 65%, 42%)`
        ctx.fillText(char, 0, 0)
        ctx.restore()
      })
    },
    async submitLogin () {
      if (this.submitting) return
      if (!this.username || !this.password || !this.captchaInput) {
        this.showNotice('请输入用户名、密码和验证码')
        return
      }
      this.submitting = true
      try {
        const session = await loginMember({ username: this.username, password: this.password, verify: this.captchaInput, remember: 0 })
        if (this.rememberUsername && this.username) window.localStorage.setItem(USERNAME_KEY, this.username)
        else window.localStorage.removeItem(USERNAME_KEY)
        this.$emit('login', session)
        this.password = ''
      } catch (error) {
        this.showNotice(error.message || '登录接口暂时无法连接')
        this.refreshCaptcha()
      } finally {
        this.submitting = false
      }
    },
    showNotice (message) {
      this.notice = message
      window.clearTimeout(this.noticeTimer)
      this.noticeTimer = window.setTimeout(() => { this.notice = '' }, 2600)
    }
  }
}
</script>

<style scoped>
.login-page { position: fixed; inset: 0; z-index: 1000; min-width: 320px; min-height: 100vh; overflow: hidden; color: #fff; background: #080a10 url('/pc/assets/login/image_login_bg.jpg') center center / cover no-repeat; font-family: "Microsoft YaHei", Arial, sans-serif; }
.login-page::before { position: absolute; inset: 0; content: ""; background: rgba(0, 0, 0, .34); pointer-events: none; }
.login-page button, .login-page input { font: inherit; }
.login-page button { cursor: pointer; }
.login-card { position: absolute; z-index: 1; left: 50%; top: 50%; width: 462px; height: 675px; transform: translate(-50%, -50%); background: rgba(0, 0, 0, .4); }
.brand { position: absolute; left: 156px; top: 22px; width: 150px; height: 120px; object-fit: contain; }
.sponsor-title { position: absolute; top: 132px; left: 0; width: 100%; height: 20px; color: #f8f5f0; font-size: 14px; line-height: 20px; text-align: center; }
.sponsor-title::before, .sponsor-title::after { position: absolute; top: 9px; width: 115px; height: 1px; content: ""; background: rgba(255,255,255,.5); }
.sponsor-title::before { left: 31px; }
.sponsor-title::after { right: 31px; }
.sponsors { position: absolute; top: 157px; left: 51px; width: 360px; height: 165px; object-fit: contain; }
.login-form { position: absolute; inset: 0; }
.field { position: absolute; left: 81px; width: 300px; height: 40px; border-radius: 20px; background: rgba(255,255,255,.5); }
.field-user { top: 352px; }
.field-password { top: 414px; }
.field-code { top: 474px; width: 209px; }
.field-icon { position: absolute; z-index: 1; left: 10px; top: 7.5px; width: 25px; height: 25px; object-fit: contain; pointer-events: none; }
.field input { position: absolute; inset: 0; width: 100%; height: 40px; padding: 0 42px 0 48px; border: 0; border-radius: 20px; outline: 0; color: #fff; background: transparent; font-size: 14px; line-height: 40px; }
.field input::placeholder { color: rgba(255,255,255,.94); opacity: 1; }
.field input:focus { box-shadow: 0 0 0 1px rgba(255,255,255,.54); }
.password-toggle { position: absolute; top: 12px; right: 10px; width: 16px; height: 16px; padding: 0; border: 0; background: transparent; }
.password-toggle img { display: block; width: 16px; height: 16px; }
.captcha { position: absolute; top: 474px; left: 292px; width: 69px; height: 40px; padding: 0; border: 0; background: #f3f1ea; }
.captcha canvas { display: block; width: 69px; height: 40px; }
.form-options { position: absolute; left: 81px; top: 530px; width: 300px; height: 20px; display: flex; justify-content: space-between; align-items: center; color: #fff; font-size: 14px; }
.remember { display: inline-flex; align-items: center; gap: 4px; cursor: pointer; }
.remember img { width: 15px; height: 15px; object-fit: contain; }
.text-link { padding: 0; border: 0; color: inherit; background: transparent; text-decoration: none; font-size: 14px; }
.text-link:hover { color: #f2cc9a; }
.login-button { position: absolute; top: 569px; left: 81px; width: 300px; height: 40px; border: 0; border-radius: 20px; color: #6e452c; background: linear-gradient(90deg, #f0d8b7 0%, #ebb87c 100%); font-size: 14px; letter-spacing: 3px; transition: filter .15s; }
.login-button:hover { filter: brightness(1.07); }
.register-line { position: absolute; left: 81px; top: 622px; width: 300px; color: #d2b79c; font-size: 14px; line-height: 20px; }
.register-line .text-link { color: #e60012; }
.quick-tools { position: absolute; z-index: 2; top: 41.2vh; right: 6px; display: flex; flex-direction: column; gap: 10px; }
.quick-tool { width: 70px; height: 56px; border: 0; background-color: transparent; background-position: center; background-repeat: no-repeat; background-size: 70px 56px; }
.quick-download { background-image: url('/pc/assets/login/btn_download_nor.png'); }
.quick-service { background-image: url('/pc/assets/login/btn_kefu_nor.png'); }
.quick-qq { background-image: url('/pc/assets/login/btn_QQ_nor.png'); }
.login-notice { position: absolute; z-index: 5; left: 50%; bottom: 28px; max-width: calc(100vw - 32px); transform: translate(-50%, 12px); padding: 12px 18px; border: 1px solid rgba(226,190,142,.45); border-radius: 5px; color: #f6e8d5; background: rgba(15,13,13,.92); box-shadow: 0 8px 28px rgba(0,0,0,.35); font-size: 13px; opacity: 0; pointer-events: none; transition: opacity .18s, transform .18s; }
.login-notice.visible { transform: translate(-50%, 0); opacity: 1; }
@media (max-width: 520px) {
  .login-card { transform: translate(-50%, -50%) scale(.82); }
  .quick-tools { right: 2px; transform: scale(.8); transform-origin: right center; }
}
@media (max-width: 390px) { .login-card { transform: translate(-50%, -50%) scale(.72); } }
@media (max-height: 700px) { .login-card { transform: translate(-50%, -50%) scale(.88); } }
</style>
